/**
 * PDP / karty: aktualizacja ceny B2B po zmianie wariantu.
 */
(function (global) {
  'use strict';

  function refreshBlock(el, grossCents) {
    if (!el || !grossCents) return;
    var bp = parseInt(el.getAttribute('data-vat-bp') || '2300', 10);
    var ratePct = bp / 100;
    var net =
      typeof global.kayerGrossToNetCents === 'function'
        ? global.kayerGrossToNetCents(grossCents, ratePct)
        : Math.round((grossCents * 10000) / (10000 + bp));
    var netEl = el.querySelector('[data-kayer-net-amount]');
    if (netEl) netEl.textContent = global.kayerFormatMoneyCents(net);
  }

  function scanBlock(block, grossCents) {
    var cc = global.kayerVatGetMarketCc ? global.kayerVatGetMarketCc() : 'PL';
    if (global.kayerVatIsEuOpenMarket && !global.kayerVatIsEuOpenMarket(cc)) return;
    if (!block) return;
    var gross =
      grossCents != null
        ? parseInt(grossCents, 10)
        : parseInt(block.getAttribute('data-gross-cents') || '0', 10);
    if (gross > 0) refreshBlock(block, gross);
  }

  function scan() {
    var cc = global.kayerVatGetMarketCc ? global.kayerVatGetMarketCc() : 'PL';
    if (global.kayerVatIsEuOpenMarket && !global.kayerVatIsEuOpenMarket(cc)) return;
    document.querySelectorAll('[data-kayer-vat-net-block]').forEach(function (block) {
      var gross = parseInt(block.getAttribute('data-gross-cents') || '0', 10);
      if (gross > 0) refreshBlock(block, gross);
    });
  }

  global.kayerRefreshProductNetPriceBlock = scanBlock;
  global.kayerRefreshProductNetPrices = scan;

  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('variant:change', function (ev) {
    var price = ev && ev.detail && ev.detail.price;
    if (price == null) return;
    var pdpBlock = document.querySelector('#kayer-pdp-vat-net-wrap [data-kayer-vat-net-block]');
    if (pdpBlock) {
      pdpBlock.setAttribute('data-gross-cents', String(price));
      refreshBlock(pdpBlock, price);
      return;
    }
    scan();
  });
})(typeof window !== 'undefined' ? window : this);
